'use strict';

var _ = require('lodash');
var ChartFaresDirective = function ChartFaresDirective($window) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/chart-fares.html'),
    controller: 'ChartFaresController',
    scope: {
      brushFilterChanged: '=',
      gridModalId: '@',
      marketTagKey: '='
    },
    link: function link($scope, element) {
      function setContainerWidth() {
        $scope.sizingParams.containerWidth = chartsContainer.width();
        $scope.$apply();
      }
      var chartsContainer = element.find('.class-usage-charts');
      var resizeHandler = _.throttle(setContainerWidth, 200);
      function isLegendChanged(current, previous) {
        for (var index = 0, dataLength = current.length; index < dataLength; index++) {
          if (current[index].selected !== previous[index].selected) {
            return true;
          }
        }
        return false;
      }
      $scope.$watch('legend', function (current, previous) {
        if (isLegendChanged(current, previous)) {
          $scope.updateChartModels();
        }
      }, true);
      $window.addEventListener('resize', resizeHandler);
      $scope.$on('$destroy', function () {
        $window.removeEventListener('resize', resizeHandler);
      });
      $scope.$on('search-criteria:searchChangeEvent', $scope.reloadChartData);
      $scope.sizingParams.containerWidth = chartsContainer.width();
    }
  };
};
ChartFaresDirective.$inject = ['$window'];
module.exports = ChartFaresDirective;